import { useDebugValue } from 'react';
import { useConditionFieldNameFieldPath } from '../fieldPaths/useConditionFieldNameFieldPath';
import { useFieldState } from '../../../contexts';

export const useConditionFieldNameErrors = () => {
  const fieldPath = useConditionFieldNameFieldPath();
  const { error } = useFieldState(fieldPath);
  useDebugValue(error);
  return error;
};
